import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { ReportsMenu } from './ReportsMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { StockWrapper } from '../data-administration/data-admininstration-list/stock/stockList'
import { MonthlyReportWrapper } from '../data-administration/data-admininstration-list/monthly-report/monthlyReportList'
import { WeeklyReportWrapper } from '../data-administration/data-admininstration-list/weekly-report/WeeklyReportList'
import { InvenotryListsWrapper } from '../data-administration/data-admininstration-list/invenotry/inventoryList'
import { UserPerformanceWrapper } from '../data-administration/data-admininstration-list/user-performance/userPerformanceList'
import { WfdWrapper } from '../data-administration/data-admininstration-list/wfd/wfdList'
import { DailyReportWrapper } from '../data-administration/data-admininstration-list/daily-report/dailyReportList'
import { SupplyLedgerReportWrapper } from '../data-administration/data-admininstration-list/supply-ledger/supplyLedgerReportList'
import { MonthlyReportWrapper2 } from '../data-administration/data-admininstration-list/monthly-report2/monthlyReportList2'
import { InclusiveAiWrapper } from '../data-administration/data-admininstration-list/Inclusive Ai/InclusiveAi'

import MaterialReport from '../data-administration/data-admininstration-list/user-performance/MonthyReports'
import { MonthlyReportWrapper2Analytics } from '../data-administration/data-admininstration-list/monthly-report2-Analytics/monthlyReportList2'
import { SupplyChainAdmin } from '../data-administration/data-admininstration-list/monthly-report2-Analytics/SupplyChainAdmin'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Reports',
    path: '/apps/reports',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportsCollectorPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<ReportsMenu />} />
        <Route
          path='inventory'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Annual Report</PageTitle>
              <InvenotryListsWrapper />
            </>
          }
        />
        <Route
          path='user-performance'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>User Perfomance</PageTitle>
              <UserPerformanceWrapper />
            </>
          }
        />
        <Route
          path='stock'
          element={
            <>
              <PageTitle
                description='View the SKU wise inventory' /* breadcrumbs={usersBreadcrumbs} */
              >
                Stock
              </PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <StockWrapper />
            </>
          }
        />
        <Route
          path='monthly-reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Monthly report</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MonthlyReportWrapper />
            </>
          }
        />
        <Route
          path='supply-chain-report'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Supply chain report</PageTitle>
              <SupplyChainAdmin />
            </>
          }
        />
        <Route
          path='monthly-reports-2'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Supply chain report</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MonthlyReportWrapper2 />
            </>
          }
        />


        <Route
          path='weekly-reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Weekly Report</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <WeeklyReportWrapper />
            </>
          }
        />

        <Route
          path='material-report'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Material Report</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MaterialReport />
            </>
          }
        />

        <Route
          path='wfd'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Traceability</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <WfdWrapper />
            </>
          }
        />
        <Route
          path='inventory'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>User</PageTitle>
              {/* <DataAdmininstrationMenu /> */}
              <MonthlyReportWrapper />
            </>
          }
        />
        <Route
          path='daily-reports'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Daily report</PageTitle>
              <DailyReportWrapper />
            </>
          }
        />
        <Route
          path='inclusiv-ai'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Inclusiv AI</PageTitle>
              <InclusiveAiWrapper />
            </>
          }
        />
        {/* <Route
          path='supply-ledger'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Supplier Ledger</PageTitle>
              <SupplyLedgerReportWrapper />
            </>
          }
        /> */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default ReportsCollectorPage
